// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/list_brand_guidelines" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { BrandGuidelinesDataParams, BrandGuidelinesResult } from "./types";
import { isListBrandGuidelinesResult } from "./validators";

export const listBrandGuidelines = reactQueryFetcherAdapter(
  "/generative_ai/list_brand_guidelines",
  (
    signal: AbortSignal,
    { appGroupId, query, limit = 20, start = 0, sortdir, sortby }: BrandGuidelinesDataParams
  ): Promise<BrandGuidelinesResult> => {
    return fetch(
      `/generative_ai/list_brand_guidelines`,
      "GET",
      {
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isListBrandGuidelinesResult
);
